import React from 'react'

function Tickets() {
  return (
    <div>Tickets</div>
  )
}

export default Tickets